import { bank } from '../../../schema';
import { denormalize } from 'normalizr';

export const selectHydrated = (state, id) => denormalize(id, bank, state.entities);

export const selectBankOptions = (state) => {
  const subjects = state.entities.banks;
  return Object.keys(subjects).map(k => ({
    id: k,
    label: subjects[k].name
  }))
};


// WEBPACK FOOTER //
// ./src/redux/modules/banks/selectors.js